import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchFeatureFlags, updateFeatureFlag} from './feature-flags-api';

export const useFeatureFlags = () =>
    useQuery({
        queryKey: ['feature-flags'],
        queryFn: fetchFeatureFlags,
    });

export const useUpdateFeatureFlag = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({key, patch}) => updateFeatureFlag(key, patch),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({queryKey: ['feature-flags']});
            onSuccess?.(variables);
        },
    });
};
